export default __webpack_public_path__ + "bf3e996f4c58c51b9ccca0e0a2884d37.svg";